import "../css/style.scss";
import $ from "jquery";

//add class green if url contains('akademia trawy)

var body = [...document.getElementsByTagName("body")][0];

if (document.location.href.indexOf("akademia-trawy") > -1) {
  body.classList.add("primary-green");
}

// Posts slider

var btn_left = document.getElementsByClassName("button-left-slider");
var btn_right = document.getElementsByClassName("button-right-slider");
var content = document.getElementsByClassName("machinesSliderContainer");

var arr_btn_left = [...btn_left];
var arr_btn_right = [...btn_right];

arr_btn_right.forEach((button, index) => {
  button.addEventListener("click", () => {
    content[index].scrollLeft += 484;
  });
});

arr_btn_left.forEach((button, index) => {
  button.addEventListener("click", () => {
    content[index].scrollLeft -= 484;
  });
});

// Posts slider youtube

var btn_left_yt = document.getElementsByClassName("button-left-slider-yt");
var btn_right_yt = document.getElementsByClassName("button-right-slider-yt");
var content_yt = document.getElementsByClassName(
  "productCardsContainerHomeBannerBelow"
);

var arr_btn_left_yt = [...btn_left_yt];
var arr_btn_right_yt = [...btn_right_yt];

arr_btn_right_yt.forEach((button, index) => {
  button.addEventListener("click", () => {
    content_yt[index].scrollLeft += 300;
  });
});

arr_btn_left_yt.forEach((button, index) => {
  button.addEventListener("click", () => {
    content_yt[index].scrollLeft -= 300;
  });
});

//scrollToTopButton

var scrollToTopButton = document.getElementById("scroll-to-top-button");

scrollToTopButton.addEventListener("click", () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
});

window.onscroll = function () {
  scrollFunction();
};

function scrollFunction() {
  if (
    document.body.scrollTop > 400 ||
    document.documentElement.scrollTop > 400
  ) {
    scrollToTopButton.style.visibility = "visible";
  } else {
    scrollToTopButton.style.visibility = "hidden";
  }
}

//mobile menu

var menuMobile = document.getElementById("nav-container-mobile");
var openMenuButton = document.getElementById("open-menu-button");
var closeMenuButton = document.getElementById("close-menu-button");

openMenuButton.addEventListener("click", () => {
  menuMobile.classList.remove("hidden");
});

closeMenuButton.addEventListener("click", () => {
  menuMobile.classList.add("hidden");
});

//live search

import LiveSearch from "./modules/LiveSearch";
const search = new LiveSearch();

import LiveSearchMachines from "./modules/LiveSearchMachines";
const liveSearchMachines = new LiveSearchMachines();

//calculator

function calculator() {
  let cows_no = 0;
  let price_no = 0;
  let cows_input = null;
  let price_input = null;
  let cows_multiplier = 20075;
  let azot_volume = 0;
  let flood_lost = 0.7;
  let application_lost = 0.1;
  let mocznik_multiplier = 1 / 460;

  function count() {
    let application_azot_assimilation = 0;
    let flood_azot_assimilation = 0;
    let application_mocznik_assimilation = 0;
    let flood_mocznik_assimilation = 0;
    let application_azot_lost = 0;
    let flood_azot_lost = 0;
    let assimilation_differences = 0;
    let mocznik_volume = 0;

    let flood_mocznik_assimilation_value = 0;
    let application_mocznik_assimilation_value = 0;

    cows_no = cows_input.val().replace(/\D+/g, "") * 1;
    price_no = price_input.val().replace(/\D+/g, "") * 1;
    azot_volume = (cows_no * cows_multiplier) / 200;
    mocznik_volume = azot_volume * mocznik_multiplier;
    flood_azot_lost = azot_volume * flood_lost;
    application_azot_lost = azot_volume * application_lost;
    flood_azot_assimilation = azot_volume - flood_azot_lost;
    application_azot_assimilation = azot_volume - application_azot_lost;

    assimilation_differences =
      application_azot_assimilation - flood_azot_assimilation;

    flood_mocznik_assimilation_value =
      flood_azot_assimilation * mocznik_multiplier * price_no;
    application_mocznik_assimilation_value =
      application_azot_assimilation * mocznik_multiplier * price_no;

    $(".show-azot").text(fixPrice(azot_volume, 0));
    $(".show-azot-t").text(fixPrice(azot_volume / 1000, 2));
    $(".flood-azot-lost").text(fixPrice(azot_volume * flood_lost, 0));
    $(".application-azot-lost").text(fixPrice(application_azot_lost, 0));
    $(".flood-azot-assimilation").text(fixPrice(flood_azot_assimilation, 0));
    $(".application-azot-assimilation").text(
      fixPrice(application_azot_assimilation, 0)
    );
    $(".flood-azot-assimilation-t").text(
      fixPrice(flood_azot_assimilation / 1000, 2)
    );
    $(".application-azot-assimilation-t").text(
      fixPrice(application_azot_assimilation / 1000, 2)
    );

    $(".show-mocznik").text(fixPrice(mocznik_volume, 2));

    $(".flood-mocznik-assimilation").text(
      fixPrice(flood_azot_assimilation * mocznik_multiplier, 2)
    );
    $(".application-mocznik-assimilation").text(
      fixPrice(application_azot_assimilation * mocznik_multiplier, 2)
    );

    $("#flood-mocznik-assimilation-value").text(
      fixPrice(flood_mocznik_assimilation_value, 2)
    );
    $("#application-mocznik-assimilation-value").text(
      fixPrice(application_mocznik_assimilation_value, 2)
    );

    $(".price-show").text(fixPrice(price_no));
    $("#differences-in-t").text(
      fixPrice(
        (application_azot_assimilation - flood_azot_assimilation) *
          mocznik_multiplier,
        2
      )
    );
    $("#differences-in-money").text(
      fixPrice(
        application_mocznik_assimilation_value -
          flood_mocznik_assimilation_value,
        2
      )
    );
  }

  function fixPrice(number, dot_places) {
    // dot_places = dot_places || 2;
    let ret = "";
    let d, r, value;
    if (dot_places === 0) return number.toFixed(0);

    value = number.toString().split(".");
    d = value[0];

    // d = number.toFixed(0);
    // d = number / 1;
    //console.log(number);
    d = formatPrice(d);
    r = (number % 1).toFixed(dot_places);

    ret = d + "," + r.substring(2);
    ret = ret.replace(".", ",");
    return ret;
  }

  function formatPrice(str) {
    let newString = "";
    if (str.length == 0) return "0";
    let counter = 1;
    for (var i = str.length - 1; i >= 0; i--) {
      newString = str[i] + newString;
      if (counter % 3 === 0) newString = " " + newString;
      counter++;
    }
    return newString;
  }

  $(document).ready(function () {
    cows_input = $("#cows");
    price_input = $("#price");
    if (cows_input.length && price_input.length) {
      //cows = cows_input.attr('value');
      //price = price_input.attr('value');
      count();
      $("#cows, #price").on("change", function () {
        count();
      });
    }
  });
}

calculator();

//research slider
import ResearchSlider from "./modules/ResearchSlider";
const researchSlider = new ResearchSlider();

//Strip till toggle button

import StripTillToggleButton from "./modules/StripTillToggleButton";
const stripTillToggle = new StripTillToggleButton();

//years slider wyniki-badan

const years = document.getElementsByClassName("year");

if (window.location.href == "http://localhost:10008/research-year-at/2022/") {
  years[1].classList.add("animate-large-text-wb");
  years[0].classList.add("animate-small-text-wb");
} else if (
  window.location.href == "http://localhost:10008/research-year-at/2023/"
) {
  years[1].classList.add("animate-small-text-wb");
  years[0].classList.add("animate-large-text-wb");
}

if (window.location.href == "http://localhost:10008/research-year-as/2022/") {
  years[1].classList.add("animate-large-text-wb");
  years[0].classList.add("animate-small-text-wb");
} else if (
  window.location.href == "http://localhost:10008/research-year-as/2023/"
) {
  years[1].classList.add("animate-small-text-wb");
  years[0].classList.add("animate-large-text-wb");
}

//reading time

import ReadingTime from "./modules/ReadingTime";
const readingTime = new ReadingTime();
